import { FetchApiResponse } from "redux/types";

export enum ChargeSummaryReportReduxTypes {
    CHARGE_SUMMARY_REPORT = "@@auth/CHARGE_SUMMARY_REPORT",
    CHARGE_SUMMARY_REPORT_SUCCESS = "@@auth/CHARGE_SUMMARY_REPORT_SUCCESS",
    CHARGE_SUMMARY_REPORT_ERROR = "@@auth/CHARGE_SUMMARY_REPORT_ERROR"
}

export type ChargeSummaryReportActionDispatch = {
    type: | ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT;
    payload: any;
}

export type ChargeSummaryReportReducerDispatch = {
    type: | ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT
    | ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_SUCCESS
    | ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<ChargeSummaryReport>
        error?: string
    }
}

export type ChargeSummaryReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type ChargeSummaryReportRequest = {
    payload: {},
    type: string
}

export type CreateChargeSummaryReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}